import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import UploadedFile from 'components/widgets/UploadedFile'

const useStyles = makeStyles(theme => ({
  alignRight: {
    textAlign: 'right',
  }
}))

const QuoteSummary = ({
  quote,
  client,
  project,
  title = '',
}) => {

  const classes = useStyles()

  if(!quote || !client || !project) return null

  const company = project.meta && project.meta.company ?
    project.meta.company :
    {}

  return (
    <div>
      <Grid container spacing={ 2 } alignItems="flex-start">
        <Grid item xs={ 6 }>
          <Typography variant="h6">
            { quote.name } { title ? ` : ${title}` : '' }
          </Typography>
          <Typography gutterBottom variant="caption">
            { quote.meta.type }
          </Typography>
        </Grid>
        <Grid item xs={ 6 } className={ classes.alignRight }>
          {
            company.logo && (
              <UploadedFile
                data={ company.logo }
                justImage
              />
            )
          }
        </Grid>
        <Grid item xs={ 6 }>
          <Typography>
            { client.name }
          </Typography>
          <Typography variant="caption" component="p">
            { client.meta.email }
          </Typography>
          {
            [
              client.meta.address1,
              client.meta.address2,
              client.meta.city,
              client.meta.county,
              client.meta.postcode,
            ].filter(s => s).map((s, i) => {
              return (
                <Typography variant="caption" component="p" key={ i }>
                  { s }
                </Typography>
              )
            })
          }
        </Grid>
        <Grid item xs={ 6 } className={ classes.alignRight }>
          <Typography>
            { company.name }
          </Typography>
          <Typography variant="caption" component="p">
            { company.email } : { company.phone }
          </Typography>
          {
            (company.address || '').split(/\n+/).map((line, i) => {
              return (
                <Typography variant="caption" component="p" key={ i }>
                  { line }
                </Typography>
              )
            })
          }
        </Grid>
      </Grid>
    </div>
  )

}

export default QuoteSummary